import { render, staticRenderFns } from "./SalesNavigation.vue?vue&type=template&id=8e8f9816"
import script from "./SalesNavigation.vue?vue&type=script&lang=ts"
export * from "./SalesNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports